var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "text-decoration-none black--text",
      attrs: {
        to: { name: "product_page", params: { product_id: _vm.product.id } },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "p-images-container",
          on: {
            mouseleave: function ($event) {
              _vm.activeImage = 0
            },
          },
        },
        [
          _c("product-heart-button", {
            staticClass: "p-image-heart",
            attrs: { "product-id": _vm.product.id },
          }),
          _c(
            "v-carousel",
            {
              staticClass: "p-images",
              attrs: {
                "hide-delimiters": "",
                "show-arrows": false,
                continuous: false,
              },
              model: {
                value: _vm.activeImage,
                callback: function ($$v) {
                  _vm.activeImage = $$v
                },
                expression: "activeImage",
              },
            },
            _vm._l(_vm.product.images, function (image, index) {
              return _c("v-carousel-item", {
                key: index,
                staticClass: "p-image",
                attrs: { src: image, disabled: _vm.dense, contain: "" },
              })
            }),
            1
          ),
          _vm.hovered && !_vm.dense
            ? _c(
                "div",
                { staticClass: "p-image-hover-container hidden-sm" },
                _vm._l(_vm.product.images, function (_, index) {
                  return _c("div", {
                    key: index,
                    staticClass: "p-image-hover",
                    on: {
                      mouseenter: function ($event) {
                        _vm.activeImage = index
                      },
                    },
                  })
                }),
                0
              )
            : _vm._e(),
          _vm.product.images.length > 1 && !_vm.dense
            ? _c("div", { staticClass: "p-delimiters-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "p-delimiters",
                    style: { transform: _vm.transform },
                  },
                  _vm._l(_vm.product.images, function (_, index) {
                    return _c("div", {
                      key: index,
                      staticClass: "p-delimiter",
                      class: { active: index === _vm.activeImage },
                    })
                  }),
                  0
                ),
              ])
            : _vm._e(),
          !_vm.dense
            ? _c("div", { staticClass: "p-labels" }, [
                _vm.product.options.length !== 0
                  ? _c(
                      "div",
                      { staticClass: "text-left" },
                      [
                        _c(
                          "v-chip",
                          {
                            attrs: { color: "info", "x-small": "", label: "" },
                          },
                          [_vm._v("Штучно")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.product.wholesale_options.length !== 0
                  ? _c(
                      "div",
                      { staticClass: "text-left" },
                      [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              color: "warning",
                              "x-small": "",
                              label: "",
                            },
                          },
                          [_vm._v("Упаковка")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pl-1 mt-1", class: { "mb-3": !_vm.dense } },
        [
          _c(
            "v-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.dense,
                  expression: "!dense",
                },
              ],
              staticClass: "flex-nowrap",
              attrs: { "no-gutters": "" },
            },
            [
              _c("v-col", [
                _c("div", { staticClass: "p-name" }, [
                  _vm._v(
                    " " + _vm._s(_vm.product.name || "Без наименования") + " "
                  ),
                ]),
                _c("div", { staticClass: "p-freshness mt-n1" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.places) +
                      " · " +
                      _vm._s(_vm.freshness) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "p-price",
              class: { "body-2 font-weight-bold": _vm.dense },
            },
            [_vm._v(" " + _vm._s(_vm.priceLabel) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }